<style src="./assets/css/raw.css" />
<style src="./assets/css/layout.css" />
<template lang="pug">
  main#app(v-if="page_ready" :class="[$route.meta.navtop && 'show_navtop', show_navleft && 'show_navleft', size, browser, modal && 'show_modal', scrollmodal && 'scrollmodal']")
    svg-sprite
    nav-top(v-if="$route.meta && $route.meta.navtop")
    nav-left.show(v-if="$route.meta && $route.meta.navleft" @mouseover="show_navleft = true" @mouseleave="show_navleft = false")
    transition(:name="mobile ? 'modal-slide' : 'modal-fade'")
      new-idea-modal(v-if="modal && modal.name === 'new_idea'" :start_box_id="modal && modal.box_id")
      idea-modal(v-else-if="modal && modal.name === 'idea'" :idea_id="modal && modal.data.id" :calendar="modal && modal.calendar" :calendar_id="modal && modal.calendar_id")
    confirm-modal(v-if="confirm_modal" :data="confirm_modal")
    admin-modal(v-if="admin_modal && !modal" :data="admin_modal.data" :name="admin_modal.name")
    transition(name="modal-fade")
      .modal-backdrop(style="background: rgba(0,0,0,0.1);" v-if="modal && modal.name ==='account'" @click="modal = null")
       .modal.column
         .account.row.center.left(v-for="account in box_accounts" :class="{selected: account.id === active_box_account.id}" @click="update_query({box_account_id: account.id})")
           .account-logo
             img(v-storage="account.logo")
           .name {{ account.name }}

    //- .dev
    //-   .row.center.between
    //-     div Admin
    //-     .checkbox(type="checkbox" :class="{active: admin}" @click="admin = !admin")
    //-   .row.center.between
    //-     div Scroll modal
    //-     .checkbox(type="checkbox" :class="{active: scrollmodal}" @click="scrollmodal = !scrollmodal")
    router-view(class="page" :key="$route.path" ref="router")
</template>

<script>
// import postsMixin from './mixins/posts'
import usersMixin from './mixins/users'
import ideasMixin from './mixins/ideas'

export default {
  mixins: [usersMixin,ideasMixin ],
  name: 'app',
  data() {
    const navigator_lang = ((navigator.userLanguage || navigator.language) === 'en') ? 'en' : 'fr'
    return {
      size: size(),
      browser: browser(),
      db: null,
      lang: localStorage.lang || navigator_lang,
      scrollmodal: false,
      show_navleft: false,
      modal: null,
      admin_modal: null,
      confirm_modal: null,
      uploading: false,
      loading_email: false,
      mail_users: [],
      email_fulldate: new Date(),
      email_lang: 'fr',
      search: null,
    }
  },
  mounted() {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
      this.resize()
    })
    // SAFARI HAck
    window.addEventListener('orientationchange', () => {
      window.location.reload()
      // this.resize()
      // setTimeout(() => {
      //   document.documentElement.style.height = `100%`;
      //     setTimeout(() => {
      //       window.scrollTo(0, 1);
      //     }, 500);
      // }, 500);
    });
    // this.$bindAsObject('db', firebase.database().ref((localStorage.ENV || 'prod') + '/public/'))
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        if (localStorage.uid === user.uid && this.$root.user) return
        this.$root.auth_ready = false
        return firebase.auth()
          .currentUser
          .getIdToken(true)
          .then(token => {
            // this.$root.id_token = token
            localStorage.setItem('id_token', token)
          })
          .then(() => { this.$root.bind_user(user) })
      }
      this.$root.user = null
      this.$root.auth_ready = true
      if (!this.check_route(this.$route) && this.$route.path !== '/login') this.$router.push({path: '/login', query: {from: this.$route.fullPath}})
    })
  },
  methods: {
    resize() {
      this.size = size()
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    change_lang() {
      const lang = this.$root.user.lang || this.lang
      const new_lang = (lang === 'fr') ? 'en' : 'fr'
      localStorage.lang = this.lang = new_lang
      set(`users.${this.$root.user_id}.lang`, new_lang)
    },
    click_element(selector) {
      document.querySelector(selector).click()
    },
    mail_select_user(user_name) {
      const uid = this.$root.users.find(v => v.name === user_name)
      if (!this.mail_users) return this.mail_users = [uid]
      if (this.mail_users.includes(uid)) return Vue.set(this, 'mail_users', this.mail_users.filter(d => d !== uid))
      this.mail_users.push(uid)
    },
    send_account_email(email_fulldate, mail_users) {
      const emails = mail_users.map(uid => this.$root.users[uid].email)
      const timestamp = new Date(email_fulldate).getTime()
      console.log('sending', {
        timestamp,
        emails,
        account_id:this.$route.query.account_id
      })
      this.loading_email= true
      axios.post('https://us-central1-lbc-calendar.cloudfunctions.net/send_account_email',
                  {
                    timestamp,
                    emails,
                    account_id:this.$route.query.account_id,
                    lang: this.email_lang,
                  }).then(() => {
                    this.$root.mail_users = []
                    this.$root.modal = null
                    this.loading_email= false
                  }).catch((e) => {
                    alert('Echec '+e.message)
                    this.$root.mail_users = []
                    this.$root.modal = null
                    this.loading_email= false
                  })

    }
  },
  computed: {
    page_ready() {
      if (!this.$route) return
      if (!this.$route.meta) return true
      if (this.$route.meta.condition) return this.$route.meta.condition(this)
    },
    mobile() {
      return !this.size.includes('laptop')
    },
    navleft() {
      return this.show_navleft && !this.mobile
    },
    email_date: {
      get() {
        return new Date(this.email_fulldate).format('%Y-%m-%d')
      },
      set(value) {
        this.email_fulldate = new Date(value.format('%Y-%m-%d') + ' ' + this.email_hour).toISOString()
      }
    },
    email_hour: {
      get() {
        return new Date(this.email_fulldate).format('%H:%M')
      },
      set(value) {
        this.email_fulldate = new Date(this.email_date + ' ' + value).toISOString()
      }
    },
  },
  watch: {
    modal() {
      if (this.modal) return document.body.className = 'show_modal'
      document.body.className = null
    }
  },
}
</script>

<style>
.dev {
  position: fixed;
  background:var(--background);
  box-shadow: var(--box-shadow);
  z-index: 1000;
  top: calc(var(--nav-top-height) + 10px);
  right: 10px;
  padding: 8px;
}
.dev > * {
  margin: 4px;
}
.dev .checkbox {
  width: 20px;
  height: 20px;
  background: white;
  border: 2px solid var(--primary);
  cursor: pointer;
  border-radius: 2px;
}
.dev .checkbox.active {
  background: var(--primary);
}

.modal {
  position: fixed;
  top: calc(var(--nav-top-height) + 12px);
  width: calc(100vw - 24px);
  left: 12px;
  max-height: 70vh;
  background: white;
  border-radius: 4px;
  overflow-y: scroll;
}
.modal.email {
  width: 520px;
  left: calc(50vw - 260px);
  padding: 16px;
}
.modal.email > * {
  margin-bottom: 12px;
}
.modal .hour {
  background: var(--background);
  width: 80px;
  height: 36px;
  padding: 4px 8px;
  font-size: 14px;
  text-align: center;
}

.modal .account-logo {
  width: 40px;
  height: 40px;
  margin-right: 12px;
}
.modal .account .name {
  font-size: 16px;
}
.modal .account.selected {
  background:rgba(0,0,0,0.1);
}
.modal .account {
  padding: 6px 12px;
  min-height: fit-content;
}
.modal button {
  width: 120px;
}
.slide-left-enter, .slide-left-leave-to { width: 0; }
.slide-left-enter-active, .slide-left-leave-active{  transition: all 3s ease-in-out;}

</style>
